import React from 'react';
import { Compass, Shield, Users, Sparkles } from 'lucide-react';

const features = [
  {
    id: 1,
    icon: 'compass',
    title: 'Sadece yürümüyorsunuz, deneyimliyorsunuz',
    description: 'Rotalarımız sizi herkesin göremediği manzaralara ve hikâyelere götürür.',
  },
  {
    id: 2,
    icon: 'shield',
    title: 'Rehberli, güvenli ve keyifli',
    description: 'Tüm yürüyüşler deneyimli rehberler eşliğinde, molalı ve dengeli tempoda ilerler.',
  },
  {
    id: 3,
    icon: 'users',
    title: 'Küçük grup, güçlü uyum',
    description: 'Max. 15 kişilik gruplarla daha samimi, keyifli ve uyumlu bir deneyim yaşarsınız.',
  },
  {
    id: 4,
    icon: 'sparkles',
    title: 'Her şey planlı, siz sadece keyfini çıkarın',
    description: 'Konaklama, transfer, yemek… Tüm detaylar hazır. Size sadece anın tadını çıkarmak kalır.',
  },
];

const iconMap = {
  compass: Compass,
  shield: Shield,
  users: Users,
  sparkles: Sparkles,
};

const WhyChooseUs = () => {
  return (
    <section className="py-12 md:py-16 bg-[#f9f9f6]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((item) => {
            const Icon = iconMap[item.icon] || Compass;
            return (
              <div key={item.id} className="text-center">
                <div className="w-14 h-14 mx-auto mb-4 bg-[#C8D843]/15 rounded-full flex items-center justify-center">
                  <Icon size={28} className="text-[#3D4A26]" strokeWidth={1.5} />
                </div>
                <h3
                  className="text-base font-bold text-[#1B1B1B] mb-2 leading-snug"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
